import React from 'react'

export default function IndividualRequest() {
  return (
    <div>IndividualRequest</div>
  )
}
